export function disableFunction(values) {
    return values.sendersFinancialInstitutionCode === "" ||
        values.destinationInstitutionCode === "" ||
        values.channelCode === "" ||
        values.originatorKYCLevel === "" ||
        values.paymentReference === "" ||
        values.originatorAccountName === "" ||
        values.originatorAccountNumber === "" ||
        values.originatorBankVerificationNumber === "" ||
        (values.transactionLocation === "") | (values.amount === "") ||
        values.narration === "";
}

export default { disableFunction }